import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  GetMigrations,
  UpdateSearchValues,
  GetMigrationReport,
} from '@migrations/state/migrations.actions';
import * as fromMigrations from '@migrations/state/migrations.reducer';
import { Subject, BehaviorSubject } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MigrationDetailModalComponent } from '../../components/migration-detail-modal/migration-detail-modal.component';
import { IMigration, MigrationState } from '@shared';

@Component({
  selector: 'migrations-main',
  templateUrl: './migrations-main.component.html',
  styleUrls: ['./migrations-main.component.scss'],
})
export class MigrationsMainComponent implements OnInit {
  modalRef: NgbModalRef;
  currentSearchCategories: string[] = [];
  currentSearchQuery = '';
  currentStateFilter = [];
  dateInterval = 30;

  filterStateArray = [
    { value: MigrationState.Running },
    { value: MigrationState.Submitted },
    { value: MigrationState.Pending },
    { value: MigrationState.Success },
    { value: MigrationState.Paused },
    { value: MigrationState.Failed },
  ];

  search$: Subject<string> = new Subject<string>();
  stateFilter$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  migrations$ = this.store.pipe(select(fromMigrations.getAllMigrations));
  successfulMigrations$ = this.store.pipe(
    select(fromMigrations.getAllSuccessfulMigrations),
  );
  failedMigrations$ = this.store.pipe(
    select(fromMigrations.getAllFailedMigrations),
  );
  isLoadingAccounts$ = this.store.pipe(
    select(fromMigrations.getMigrationsLoading),
  );

  constructor(
    private store: Store<fromMigrations.State>,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.store.dispatch(
      new UpdateSearchValues({
        query: this.currentSearchQuery,
        dateInterval: this.dateInterval,
        stateFilter: this.currentStateFilter,
      }),
    );
    this.store.dispatch(new GetMigrations());
  }

  loadAccounts(query = this.currentSearchQuery) {
    this.currentSearchQuery = query;
    this.search$.next(this.currentSearchQuery);
    this.store.dispatch(
      new UpdateSearchValues({
        query: query,
        dateInterval: this.dateInterval,
        stateFilter: this.currentStateFilter,
      }),
    );
  }

  onFilterChange(value) {
    this.currentStateFilter = this.currentStateFilter.find((f) => f === value)
      ? this.currentStateFilter.filter((v) => v !== value)
      : [...this.currentStateFilter, value];
    this.stateFilter$.next(this.currentStateFilter);
    this.store.dispatch(
      new UpdateSearchValues({
        query: this.currentSearchQuery,
        dateInterval: this.dateInterval,
        stateFilter: this.currentStateFilter,
      }),
    );
  }

  setDateInterval(interval) {
    this.dateInterval = parseInt(interval, 10);
    this.store.dispatch(
      new UpdateSearchValues({
        query: this.currentSearchQuery,
        dateInterval: this.dateInterval,
        stateFilter: this.currentStateFilter,
      }),
    );
  }

  openMigrationModal(migration) {
    this.modalRef = this.modalService.open(MigrationDetailModalComponent, {
      backdrop: 'static',
      keyboard: false,
    });
    const componentInstance = this.modalRef.componentInstance;

    componentInstance.migration = migration;
  }

  getMigrationReport(migration: IMigration) {
    this.store.dispatch(new GetMigrationReport(migration));
  }
}
